module.exports = __webpack_public_path__ + "static/media/river-birds-eye.1e316491.jpeg";